package gr.web.icyleds.components.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import gr.tech.pdfgenerator.components.widgets.loadingSpinner
import gr.tech.pdfgenerator.infrastructure.api.logoutUser
import gr.tech.pdfgenerator.infrastructure.session.UserSession
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY
import gr.tech.pdfgenerator.util.BACKEND
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*


@Composable
fun NavHeader() {
    val scope = rememberCoroutineScope()
    val ctx = rememberPageContext()

    Nav(Modifier
        .fillMaxWidth()
        .classNames("navbar")
        .toAttrs{
            attr("role", "navigation")
            attr("aria-label", "main navigation")
        }) {
        Div(Modifier.classNames("navbar-brand").toAttrs()) {
            Link(
                modifier = Modifier.classNames("navbar-item"),
                path = "/",
                variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)
            ) {
                H1(Modifier.classNames("title").toAttrs()) { Text("PDF Genie") }
            }
        }
        Div(Modifier.classNames("navbar-menu").id("navbarBasic").toAttrs()) {
            Div(Modifier.classNames("navbar-start").toAttrs()) {
                Link("/projects", Modifier
                    .fontFamily(FONT_FAMILY)
                    .classNames("navbar-item"),
                    variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)
                ) {
                    Text("Project Selection")
                }
            }

            Div(Modifier.classNames("navbar-end").toAttrs()) {
                Div(Modifier.classNames("navbar-item").toAttrs()) {
                    Div(Modifier.classNames("buttons").toAttrs()) {
                        if (UserSession.info.value != null) {
                            SpanText("Hello, ${UserSession.info.value!!.name}!")
                            Spacer()
                            Span(
                                attrs = Modifier.margin(0.px).classNames("button", "is-light")
                                    .onClick {
                                        scope.launch { logoutUser() }
                                    }
                                    .toAttrs(),
                            ) {
                                Text("Sign Out")
                            }
                        } else if (!UserSession.isLoggedIn()) {
                            loadingSpinner(
                                IconSize.SM
                            )
                        } else {
                            Link("/signin", Modifier.margin(0.px).classNames("button", "is-light")) {
                                Text("Sign In")
                            }
                        }
                    }
                }
            }
        }
    }
}

/*
 ----- SITE STYLES -----
*/

val HoverLinkStyle = CssStyle {
    base {
        Modifier
    }
    hover {
        Modifier

    }
}




/*

    ALL OLD, NOT BEING USED

*/
@Composable
fun NavLink(
    context: PageContext,
    path: String,
) {
    context.router.navigateTo(path)
}

val NavHeaderStyle = CssStyle {
    base { Modifier.fillMaxWidth().padding(topBottom = 1.cssRem, leftRight = 1.em) }
    Breakpoint.MD {  Modifier.fillMaxWidth().padding(topBottom = 1.cssRem, leftRight = 5.cssRem) }
}

@Composable
fun NavLink(tolink: String, Text: String) {
    Link(tolink, Modifier
        .textDecorationLine(TextDecorationLine.None)
        .color(Colors.White)) {
        SpanText(Text, Modifier.color(Colors.Blue))
    }
}

@Composable
private fun MenuItems() {
    NavLink("/", "HOME")
    NavLink("/", "LOGIN")
}


val SideMenuSlideInAnim = Keyframes {
    from {
        Modifier.translateX(100.percent)
    }

    to {
        Modifier
    }
}

// Note: When the user closes the side menu, we don't immediately stop rendering it (at which point it would disappear
// abruptly). Instead, we start animating it out and only stop rendering it when the animation is complete.
enum class SideMenuState {
    CLOSED,
    OPEN,
    CLOSING;

    fun close() = when (this) {
        CLOSED -> CLOSED
        OPEN -> CLOSING
        CLOSING -> CLOSING
    }
}

//Deprecated, leaving here for notes
@Composable
private fun SideMenu(menuState: SideMenuState, close: () -> Unit, onAnimationEnd: () -> Unit) {
    Overlay(
        Modifier
            .setVariable(OverlayVars.BackgroundColor, Colors.Transparent)
            .onClick { close() }
    ) {
        key(menuState) { // Force recompute animation parameters when close button is clicked
            Column(
                Modifier
                    .fillMaxHeight()
                    .width(clamp(10.cssRem, 33.percent, 10.cssRem))
                    .align(Alignment.CenterEnd)
                    // Close button will appear roughly over the hamburger button, so the user can close
                    // things without moving their finger / cursor much.
                    .padding(top = 1.cssRem, leftRight = 1.cssRem)
                    .gap(1.5.cssRem)
                    .backgroundColor(Colors.Grey)
                    .animation(
                        SideMenuSlideInAnim.toAnimation(
                            duration = 200.ms,
                            timingFunction = if (menuState == SideMenuState.OPEN) AnimationTimingFunction.EaseOut else AnimationTimingFunction.EaseIn,
                            direction = if (menuState == SideMenuState.OPEN) AnimationDirection.Normal else AnimationDirection.Reverse,
                            fillMode = AnimationFillMode.Forwards
                        )
                    )
                    .borderRadius(topLeft = 2.cssRem)
                    .onClick { it.stopPropagation() }
                    .onAnimationEnd { onAnimationEnd() },
                horizontalAlignment = Alignment.End
            ) {
                Column(Modifier.padding(right = 0.75.cssRem).gap(1.5.cssRem).fontSize(1.4.cssRem), horizontalAlignment = Alignment.End) {
                    MenuItems()
                }
            }
        }
    }
}
